var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-view',{attrs:{"headers":_vm.headers,"routes":_vm.routes,"url":_vm.url,"row-actions":_vm.rowActions,"top-actions":_vm.topActions,"sort-by":"name","title":"Calendars","texts":{
    deleteAreYouSure:
      'All portals, places, resources, schedules connected to the calendar will also be deleted! Are you sure?',
  }},scopedSlots:_vm._u([{key:"item.isDefault",fn:function(ref){
  var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t(item.isDefault ? 'Yes' : 'No'))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }